import { useEffect, useState } from "react";

const useImage = (fileName: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      try {
        setLoading(true);
        const response = await import(`../../assets/images/${fileName}.png`);
        setImage(response.default);
      } catch (err) {
        setError("Error loading image");
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [fileName]);

  return {
    loading,
    error,
    image,
  };
};

export default useImage;
